import { type ProductizedServiceIndustries_productizedService$key } from '#app/__generated__/relay/ProductizedServiceIndustries_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { RolesList } from '#app/components/RolesList/RolesList.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

type ProductizedServiceIndustriesProps = {
  readonly productizedServiceRef: ProductizedServiceIndustries_productizedService$key;
};

export const ProductizedServiceIndustries = ({
  productizedServiceRef,
}: ProductizedServiceIndustriesProps) => {
  const {
    industryCategories: { edges },
  } = useFragment<ProductizedServiceIndustries_productizedService$key>(
    graphql`
      fragment ProductizedServiceIndustries_productizedService on ProductizedService {
        industryCategories {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    `,
    productizedServiceRef,
  );
  const industries = edges.map(({ node: { id, name } }) => ({
    id,
    name,
  }));

  if (!industries.length) {
    return null;
  }

  return (
    <Container>
      <Text textStyle="subtitleRegular">Industries</Text>
      <List>
        <RolesList
          limit={3}
          readOnly
          roles={industries}
          variant="condensed"
        />
      </List>
    </Container>
  );
};
